import type { Invoice } from "@/features/invoices/types";

const STARTING_NUMBER = 1000;

/**
 * Global sequence across all clients — legacy scopes this per accounting
 * "entity" (firm), a concept this app doesn't model yet. Only confirmed
 * (non-DRAFT) invoices count toward the sequence, matching legacy's
 * `invoice_status <> 'DRAFT'` uniqueness filter.
 */
export function nextInvoiceNumber(invoices: Invoice[]): string {
  const confirmedNumbers = invoices
    .filter((inv) => inv.status !== "DRAFT")
    .map((inv) => Number(inv.invoiceNumber))
    .filter((n) => Number.isInteger(n));

  let next = (confirmedNumbers.length > 0 ? Math.max(...confirmedNumbers) : STARTING_NUMBER - 1) + 1;
  const taken = new Set(confirmedNumbers);
  while (taken.has(next)) next++;

  return String(next);
}

/** "DRAFT N" — N is this client's DRAFT-status invoice count + 1. */
export function nextDraftLabel(invoices: Invoice[], clientId: string): string {
  const draftCount = invoices.filter((inv) => inv.clientId === clientId && inv.status === "DRAFT").length;
  return `DRAFT ${draftCount + 1}`;
}
